import { call, put, takeEvery, all } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import {
  createReqRefRoutine
} from '../../routines';
import { createRefReq } from '../../../../services/referenceRequestService';
import { successToast, errorToast } from '../../../../common/helpers/toastrHelper';

function* createRefRequest({ payload }: Routine<any>) {
  try {
    yield call(createRefReq, payload);
    yield put(createReqRefRoutine.success());
    yield call(
      successToast,
      'Success! Remind candidates to check spam folders',
      'toast.referenceRequestSuccess'
    );
  } catch (error) {
    yield put(createReqRefRoutine.failure(error.message));
    yield call(errorToast, error.message);
  }
}

function* watchCreateRefReq() {
  yield takeEvery(createReqRefRoutine.TRIGGER, createRefRequest);
}

export default function* step5Saga() {
  yield all([watchCreateRefReq()]);
}
